import { ReactNode } from 'react'
import { CSSObject } from '@emotion/react';
import { IComponentCss } from '../styles';
import { Grid, Typography } from '@mui/material';

type VerticalTabContentProps = {
    title: string,
    children?: ReactNode,
    contentWrapStyle?: CSSObject,
}

const css: IComponentCss = {
    titleWrap: {
        height: '82px',
        width: '100%',
        borderBottom: '1px solid #E0E0E0',
        padding: '30px 16px 30px 16px',
        background: '#F9FBFA',
        borderRadius: '0px 4px 0px 0px',
    },
    title: { fontWeight: 700 },
    contentWrap: {
        padding: '16px 16px 16px 16px',
    },
}


export const VerticalTabContent = ({
    title,
    children,
    contentWrapStyle,
}: VerticalTabContentProps) => {
    return (
        <>
            {/* Заголовок */}
            <Grid
                container
                sx={css.titleWrap}
                justifyContent='space-between'
            >
                <Typography
                    component='h3'
                    color='initial'
                    sx={css.title}
                >
                    {title}
                </Typography>
            </Grid>

            {/* Контент */}
            <Grid
                container
                sx={{
                    ...css.contentWrap,
                    ...contentWrapStyle,
                }}
            >
                {children}
            </Grid>
        </>
    )
}